var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rightmenu"},[_c('div',{staticStyle:{"width":"120px","height":"290px"}},[_c('el-image',{staticStyle:{"width":"inherit","height":"inherit","border-radius":"10px 10px 10px 10px"},attrs:{"src":_vm.leftgg,"fit":"fill"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }